import { z } from "zod"
import db, { Pipeline, Brand, Geography, Language, Order } from "db"
import { CreatePipeline } from "../validations"
import { NotFoundError } from "blitz"

type PipelinePublicUrlProps = Pick<Pipeline, "name"> & {
  brand: Pick<Brand, "name">
  geography: Pick<Geography, "name">
  language: Pick<Language, "code">
}

// Return pipeline public URL, e.g https://v3.stockholmdiet.com/eu-en/p-series
export default function getPipelinePublicUrl(pipeline: PipelinePublicUrlProps) {
  const host = pipeline.brand.name.toLowerCase()
  const geography = pipeline.geography.name.toLowerCase()
  const language = pipeline.language.code.toLowerCase()
  const name = pipeline.name
  return new URL(`https://${host}/${geography}-${language}/${name}/`)
}

export type { PipelinePublicUrlProps }

// return pipeline public URL, but for input you can provide CreatePipeline data from app/pipelines/validations.ts
export async function getPipelinePublicUrlFromParams(
  data: Pick<z.infer<typeof CreatePipeline>, "name" | "brandId" | "geographyId" | "languageId">
) {
  const { brandId, languageId, geographyId } = data

  const [brand, language, geography] = await db.$transaction([
    db.brand.findFirst({ where: { id: brandId } }),
    db.language.findFirst({ where: { id: languageId } }),
    db.geography.findFirst({ where: { id: geographyId } }),
  ])

  if (!brand || !language || !geography) throw new NotFoundError()

  return getPipelinePublicUrl({ name: data.name, brand, language, geography })
}

export function getPipelinePublicUrlFromPathPrefix(
  order: Pick<Order, "pathPrefix">,
  brand: Pick<Brand, "name">
): string {
  return `https://${brand.name.toLowerCase()}${order.pathPrefix}`
}
